/** Student documents form section. */
import * as React from 'react';
import { FileText } from 'lucide-react';
import { FileDropzone } from '@/components/common/FileDropzone';
import { defaultUpload } from '@/components/students/remote/student-form-utils';

/** Props for {@link StudentDocumentsSection}. */
type StudentDocumentsSectionProps = Readonly<{
  formData: Record<string, any>;
  onChange: (path: string, value: any) => void;
  studentUserId: string;
  companyId: string;
  onFileSelect?: (key: string, file: File | null) => void;
}>;

/** Student documents form section. */
export function StudentDocumentsSection({
  formData,
  onChange,
  studentUserId,
  companyId,
  onFileSelect,
}: StudentDocumentsSectionProps) {
  const buildUploadFn = React.useCallback(
    (file: File): Promise<string> => defaultUpload(file, companyId, studentUserId),
    [companyId, studentUserId],
  );

  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <FileText className="w-4 h-4" />
        Bulletin scolaire
      </h4>
      <div className="grid grid-cols-1 gap-4">
        <FileDropzone
          label="Bulletin scolaire"
          value={formData.schoolReport?.documentLink ?? ''}
          accept=".pdf,.jpg,.jpeg,.png,.webp"
          maxSize={5 * 1024 * 1024}
          uploadFn={onFileSelect ? undefined : buildUploadFn}
          onFileSelect={onFileSelect ? (file) => onFileSelect('schoolReportFile', file) : undefined}
          onChange={(url) => {
            onChange('schoolReport.documentLink', url);
            if (url) {
              const parts = url.split('/');
              const raw = parts.at(-1)?.split('?')[0] ?? '';
              onChange('schoolReport.documentName', decodeURIComponent(raw));
              onChange('schoolReport.uploadDate', new Date().toISOString().slice(0, 10));
            }
          }}
        />
      </div>
    </div>
  );
}
